import { SignalQueueFactory, call, createContext, createSignal, each, spawn, } from "effection";
import { matcher } from "./matcher.js";
import { createFilterQueue } from "./queue.js";
export const ActionContext = createContext("starfx:action", createSignal());
export function useActions(pattern) {
    return {
        [Symbol.iterator]: function* () {
            const actions = yield* ActionContext.expect();
            const match = matcher(pattern);
            yield* SignalQueueFactory.set(() => createFilterQueue(match));
            return yield* actions;
        },
    };
}
export function emit({ signal, action, }) {
    if (Array.isArray(action)) {
        if (action.length === 0) {
            return;
        }
        action.map((a) => signal.send(a));
    }
    else {
        signal.send(action);
    }
}
export function* put(action) {
    const signal = yield* ActionContext.expect();
    return emit({
        signal,
        action,
    });
}
export function* take(pattern) {
    const fd = useActions(pattern);
    for (const action of yield* each(fd)) {
        return action;
    }
    return { type: "take failed, this should not be possible" };
}
export function* takeEvery(pattern, op) {
    const fd = useActions(pattern);
    for (const action of yield* each(fd)) {
        yield* spawn(() => op(action));
        yield* each.next();
    }
}
export function* takeLatest(pattern, op) {
    const fd = useActions(pattern);
    let lastTask;
    for (const action of yield* each(fd)) {
        if (lastTask) {
            yield* lastTask.halt();
        }
        lastTask = yield* spawn(() => op(action));
        yield* each.next();
    }
}
export function* takeLeading(pattern, op) {
    while (true) {
        const action = yield* take(pattern);
        yield* call(() => op(action));
    }
}
export function* waitFor(predicate) {
    const init = yield* call(predicate);
    if (init) {
        return;
    }
    while (true) {
        yield* take("*");
        const result = yield* call(predicate);
        if (result) {
            return;
        }
    }
}
export function getIdFromAction(action) {
    return typeof action === "function" ? action.toString() : action.payload.key;
}
export const API_ACTION_PREFIX = "";
export function createAction(actionType) {
    if (!actionType) {
        throw new Error("createAction requires non-empty string");
    }
    const fn = (payload) => ({
        type: actionType,
        payload,
    });
    fn.toString = () => actionType;
    return fn;
}
